import axios from "axios";
import { API_BASE_URL } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }) {
      const store = this;
      try {
        let response = await axios({
          method: "get",
          url: API_BASE_URL + `/customer?lookup=true`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        });
        const obj = response.data.data;
        let customers = [];
        obj.forEach(function(customer) {
          customers.push({
            id: parseInt(customer.id),
            name: customer.name,
            phone: customer.phone,
            date: customer.date
          });
        });
        if (customers.length > 0) {
          store.dispatch("entities/customerLookups/insertOrUpdate", {
            data: customers
          });
        }
        store.dispatch("entities/settings/setIsOffline", false);
      } catch (error) {
        store.dispatch("entities/settings/setIsOffline", true);
      }
    }
  }
};
